import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BannerGroupsInlineStyles = /*#__PURE__*/function () {
  function BannerGroupsInlineStyles() {
    _classCallCheck(this, BannerGroupsInlineStyles);
  }

  _createClass(BannerGroupsInlineStyles, null, [{
    key: "groups",
    value: function groups(_ref) {
      var antiAdBlocker = _ref.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-groups",
        style: {
          marginTop: 10,
          clear: "both"
        }
      };
    }
  }, {
    key: "group",
    value: function group(_ref2) {
      var _ref2$group = _ref2.group,
          groupBg = _ref2$group.groupBg,
          groupBorderRadius = _ref2$group.groupBorderRadius,
          groupBorderColor = _ref2$group.groupBorderColor,
          groupPadding = _ref2$group.groupPadding,
          groupBorderWidth = _ref2$group.groupBorderWidth,
          groupInheritBg = _ref2$group.groupInheritBg,
          headlineFontSize = _ref2$group.headlineFontSize,
          headlineFontColor = _ref2$group.headlineFontColor,
          headlineFontWeight = _ref2$group.headlineFontWeight,
          antiAdBlocker = _ref2.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-group",
        style: {
          color: headlineFontColor,
          fontSize: +headlineFontSize,
          fontWeight: headlineFontWeight,
          background: groupInheritBg ? undefined : groupBg,
          border: groupBorderWidth > 0 ? "".concat(groupBorderWidth, "px solid ").concat(groupBorderColor) : undefined,
          padding: groupPadding.map(function (p) {
            return "".concat(p, "px");
          }).join(" "),
          borderRadius: +groupBorderRadius,
          textAlign: "left"
        }
      };
    }
    /**
     * Use `visible` together with `useLayoutEffect` to avoid flickering.
     * This is needed because the SVG icons of ant are a bit flickering.
     */

  }, {
    key: "checkbox",
    value: function checkbox(_ref3, visible, checked, isDisabled, fontSize) {
      var borderRadius = _ref3.layout.borderRadius,
          _ref3$group = _ref3.group,
          headlineFontSize = _ref3$group.headlineFontSize,
          checkboxBg = _ref3$group.checkboxBg,
          checkboxBorderWidth = _ref3$group.checkboxBorderWidth,
          checkboxBorderColor = _ref3$group.checkboxBorderColor,
          checkboxActiveBg = _ref3$group.checkboxActiveBg,
          checkboxActiveBorderColor = _ref3$group.checkboxActiveBorderColor,
          checkboxActiveColor = _ref3$group.checkboxActiveColor,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      var useFontSize = fontSize || headlineFontSize;
      var height = +useFontSize + +checkboxBorderWidth * 2 + 6;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-checkbox",
        style: {
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.5 : undefined,
          color: checked ? checkboxActiveColor : checkboxBg,
          display: visible ? "inline-block" : "none",
          background: checked ? checkboxActiveBg : checkboxBg,
          border: "".concat(checkboxBorderWidth, "px solid ").concat(checked ? checkboxActiveBorderColor : checkboxBorderColor),
          padding: 3,
          height: height,
          width: height,
          marginRight: 10,
          borderRadius: +borderRadius,
          verticalAlign: "middle",
          lineHeight: 0
        }
      };
    }
  }, {
    key: "description",
    value: function description(_ref4) {
      var fontWeight = _ref4.design.fontWeight,
          _ref4$group = _ref4.group,
          descriptionFontColor = _ref4$group.descriptionFontColor,
          descriptionFontSize = _ref4$group.descriptionFontSize,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-group-description",
        style: {
          color: descriptionFontColor,
          fontSize: +descriptionFontSize,
          fontWeight: fontWeight,
          marginTop: 5
        }
      };
    }
  }, {
    key: "linkMore",
    value: function linkMore(_ref5, isHover) {
      var linkTextDecoration = _ref5.design.linkTextDecoration,
          _ref5$group = _ref5.group,
          linkColor = _ref5$group.linkColor,
          linkHoverColor = _ref5$group.linkHoverColor,
          antiAdBlocker = _ref5.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-group-more",
        style: {
          color: isHover ? linkHoverColor : linkColor,
          textDecoration: linkTextDecoration
        }
      };
    }
  }, {
    key: "cookie",
    value: function cookie(_ref6) {
      var antiAdBlocker = _ref6.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-cookie",
        style: {
          marginTop: 10
        }
      };
    }
  }, {
    key: "cookieProperty",
    value: function cookieProperty(_ref7) {
      var _ref7$group = _ref7.group,
          groupBorderWidth = _ref7$group.groupBorderWidth,
          groupBorderColor = _ref7$group.groupBorderColor,
          antiAdBlocker = _ref7.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-cookie-prop",
        style: {
          borderLeft: groupBorderWidth > 0 ? "1px solid ".concat(groupBorderColor) : undefined,
          paddingLeft: 15
        }
      };
    }
  }]);

  return BannerGroupsInlineStyles;
}();

export { BannerGroupsInlineStyles };